export default __webpack_public_path__ + "static/media/Bjorn_SE.f7aa6b29.png";